import { render, staticRenderFns } from "./platformCouponManage.vue?vue&type=template&id=97dc4aa0&scoped=true"
import script from "./platformCouponManage.vue?vue&type=script&lang=js"
export * from "./platformCouponManage.vue?vue&type=script&lang=js"
import style0 from "./platformCouponManage.vue?vue&type=style&index=0&id=97dc4aa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97dc4aa0",
  null
  
)

export default component.exports